module.exports = __webpack_public_path__ + "img/.zip.8d1f7a47.svg";